import NP from "./NP";

interface IAjax {
	Url: string,
	Type: string,
	Headers: any,
	Data: any
}

NP.ajax = function (settings: IAjax)
{
	if (settings)
	{
		let resp: any;
		return new Promise((resolve, reject) =>
		{
			fetch(settings.Url, {
				method: settings.Type || "GET",
				headers: settings.Headers,
				body: settings.Data || null
			})
				 .then((response) =>
				 {
					 resp = response;
					 if (response.status >= 300)
					 {
						 //server error
						 response.text().then((data: string) =>
						 {
							 reject({
								 data,
								 status: resp.status,
								 headers: resp.headers
							 });
						 });
					 }
					 else
					 	response.text().then((data: any) =>
						 {
							 resolve({
								 data,
								 status: resp.status,
								 headers: resp.headers
							 });
						 });
				 })
				 .catch((response: any) =>
				 {
					 reject(response);
				 })
		})
	}
};

NP.ajax.getFirstValue = function (obj: any)
{
	for (let i in obj)
	{
		if (obj.hasOwnProperty(i))
			return obj[i];
	}
};